package com.milta.core.observability

// Web dashboard is out of scope for the GlitchTip rollout (separate, later batch): no SDK on js.
internal actual fun platformCaptureException(throwable: Throwable, source: String?, status: Int?) = Unit

internal actual fun platformSetUser(accountId: String, tenantId: String?, role: String?) = Unit

internal actual fun platformClearUser() = Unit
